<template>
  <div class="userWrap">
    <div class="cardexpireList">
      <ul>
        <li v-for="(item,index) in docslist" :key="item.id">
          <div class="ruWrap">
            <img src="./../../assets/img/images/imgE.png" class="L imgT" />
            <div class="ruTop">
              <h3>{{item.cardname}}</h3>
              <p>{{item.cardnumber}}</p>
              <p>{{item.remark}}</p>
            </div>
            <div class="R rightBtn" v-if="item.cardStatus == '1'" @click="postpone(item.delayUrl)">{{item.delayType}}</div>
          </div>
        </li>
      </ul>
      <div v-if="docslist.length==0" style="text-align:center">
        <br />
        <br />当前没有不能使用的卡~
      </div>
      <div class="bottomheight"></div>
    </div>
  </div>
</template>
<script>
import * as api from '@/api'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      token: '',
      sign: '',
      docslist: [],
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
    this.openId = this.$route.query.openId;
    this.userId = this.$route.query.sign;
  },
  components: {},

  mounted() {
    this.cardList()
  },
  methods: {
    async postpone(delayUrl){
      let accountUrl = `https://account.kangou.cn/cardlist.html#/?token=${this.token}&sign=${this.sign}&openId=${this.openId}`
      let toJfen = `/pages/pagePersonal/pagePersonal?accountUrl=${encodeURIComponent(accountUrl)}`;
      let dataJson = {
        goodsType: 50000, 
        backUrl: toJfen, 
        notifyUrl: `https://accountapi.kangou.cn/api/code/huidiaoPost`, 
        source: 3, 
        openId: this.openId
      };
      //十分钟的毫秒数
      var ten = 10 * 60 * 1000;
      //当前时间之后的十分钟
      var expireTime = new Date(Date.parse(new Date())+ten).getTime()
      //拼接地址
      let payDelayUrl = delayUrl + `&userId=${this.userId}&data=${encodeURIComponent(JSON.stringify(dataJson))}&expireTime=${expireTime}`;
      window.location.href = payDelayUrl;
    },
    async cardList() {
      let _this = this
      try {
        let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj';
        let testSign = 'dpbijiiiefibmadgopamipinnnpnphof';
        localStorage.setItem('reToken', _this.token == undefined ? testToken : _this.token);
        let info = {
          sign: _this.sign == undefined ? testSign : _this.sign, 
          cardRights: '50000'
        };
        const { code, data, message } = await api.user.invalidCardList(info);
        if (code == '000000') {
          this.docslist = data;
        }
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
@import '../../assets/css/stylesheet.css'
.userWrap
  width 100%
  height 100%
  overflow auto
  background #f5f5f5
.cardexpireList
  width calc(100% - 40px)
  margin 20px auto
.cardexpireList li
  width 100%
  height 265px
  background url('../../assets/img/images/bgGrayCard.png?v=1') no-repeat center center
  background-size cover
  margin 20px 0
  color #fff
  border-radius 15px
.ruWrap
  width calc(100% - 40px)
  margin 0 auto
  position relative
.ruWrap img
  width 100px
  height 100px
.poWrap
  width calc(100% - 60px)
  margin 70px auto 0
  height auto
.poWrap span
  border 1px solid #ff799e
  background #ff799e
  display inline-block
  margin-left 10px
  padding 0px 5px
  border-radius 5%
.poWrap em
  font-size 33px
.L
  float left
.R
  float right
  font-size 28px
  line-height 53px
  height 33px
.ruTop
  padding-top 50px
  width 400px
.ruTop h3
  font-size 34px
.ruTop p
  font-size 28px
.cardexpireList .rightBtn
  position absolute
  top 120px
  right 80px
  color: red
.cardexpireList .imgT
  margin 50px 30px 0 30px
  margin-top 60px
i
  vertical-align middle
  font-size 18px
.bottom
  position fixed
  bottom 0px
  background-color #fff
  width 100%
  height 80px
  text-align center
.item1
  width 50%
  background #ff1734
  float left
.item1 p
  margin 0
  font-size 28px
  color #fff
  line-height 80px
.item2
  width 50%
  background #999999
  float left
.item2 p
  margin 0
  font-size 28px
  color #fff
  line-height 80px
.bottomheight
  height 100px
</style>


// WEBPACK FOOTER //
// src/view/cardexpirelist/index.vue